export default "__VITE_ASSET__hGI9Xrni__"